module.exports = __webpack_public_path__ + "static/media/logo-on.c7838430.png";